import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Token } from '../services/token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(Token);
  const token = tokenService.getToken();

  const headers: Record<string, string> = { 'Content-Type': 'application/json' };

  if (token) headers['Authorization'] = `Bearer ${token}`;

  req = req.clone({ setHeaders: headers });

  return next(req);
};
